import { AxiosError } from 'axios';
import store from '@/store';
import router from '@/router';
import Vue from 'vue';

const errorInterceptor = (error: AxiosError) => {
  if (error?.response?.status === 400 && error?.response?.data?.message === 'Email is already in use!') {
    Vue.prototype.$notify({
      group: 'app',
      type: 'error',
      title: 'Fehler',
      text: 'Die E-Mailadresse wird bereits verwendet. Bitte wählen Sie eine andere E-Mail-Adresse.'
    });
    return Promise.reject();
  }
  if (error.message && error.message === 'aborted') {
    return Promise.reject(error);
  }
  if (error.response && error.response.status === 401) {
    if (router.currentRoute.name !== 'media-center-select') {
      router.push({ name: 'media-center-select' });
    }
  } else if (error.response && error.response.status === 409) {
    return Promise.reject(error);
  } else if (error.response && error.response.status === 404) {
    store.commit('SET_ERROR_CODE', 404);
  } else if (error.response && error.response.status === 400) {
    if (error.response.config.url?.includes('account/')) {
      return Promise.reject(error);
    }
    store.commit('SET_ERROR_CODE', 400);
    store.commit('SET_ERROR_MESSAGE', error.response.data.message);
  } else {
    store.commit('SET_ERROR_CODE', 500);
  }
  return Promise.reject(error);
};

export default errorInterceptor;
